//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ProductImageWatermark',
  props: {
    compact: {
      type: Boolean,
      default: false
    }
  },
  // computed: {
  //   markSrc () {
  //     const key = (this.$config.STORE_LOGO || 'fashion').toString().trim()
  //     if (!key) {
  //       return ''
  //     }
  //     // return `/icons/${key}/${key}-icon-grande.png`
  //     return `assets/img/${$config.STORE_LOGO}-logo-web.png`
  //   }
  // }
}
